<div
  class="root"
  [class.root--chips]="displayMode === 'chips' && filterItems.length > 0"
>
  <ng-container *ngIf="displayMode === 'chips'; else inlineDetails">
    <div
      *ngFor="let item of filterItems"
      class="chip"
    >
      <span class="key">{{ item.id }}</span>
      <span class="value">{{ item.name }}</span>
    </div>
  </ng-container>

  <ng-template #inlineDetails>
    <ng-container *ngFor="let item of filterItems; let last = last">
      <b>{{ item.id }}:</b> {{ item.name }}<ng-container *ngIf="!last">; </ng-container>
    </ng-container>
  </ng-template>
</div>
